export function useBusinessContact() {
  const config = useRuntimeConfig().public;
  const email = computed(() =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(config.contactEmail))
      ? String(config.contactEmail)
      : '',
  );
  const phone = computed(() =>
    /^\+?[\d\s()-]{7,20}$/.test(String(config.contactPhone)) ? String(config.contactPhone) : '',
  );
  const phoneHref = computed(() => 'tel:' + phone.value.replace(/[^\d+]/g, ''));
  const phoneDisplay = computed(() => String(config.contactPhoneDisplay || phone.value));
  return { email, phone, phoneHref, phoneDisplay };
}
